'use client';

import styled, { css } from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.nav`
  display: flex;
  flex-direction: row;

  position: fixed;
  top: 0;
  right: 0;

  height: 100vh;
  width: 100%;
  visibility: hidden;
  transition: visibility 0.42s ease-in-out;

  ${({ $opened }) =>
    $opened &&
    css`
      visibility: visible;

      ${Contents} {
        transform: translateX(0);
      }
    `}
`;

export const Overlay = styled.div`
  flex: 1;

  background: rgba(40, 39, 40, 0.3);
  backdrop-filter: blur(1px);
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);

  width: 300px;
  height: 100vh;
  padding: 36px 24px;
  gap: 16px;

  transition: transform 0.42s ease-in-out;
  background-color: ${colors.gray0};

  @media (max-width: ${breakpoints.smallMobile}) {
    width: 100%;
  }

  overflow: auto;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 16px;

  &:last-child {
    margin-top: 8px;
    border-top: 1px solid ${colors.gray3};
    padding-top: 24px;
  }

  * {
    width: 100%;
  }
`;
